import { useState } from "react";
import { memeItems } from "@/mocks/gossip";

function MemeCard({ item }: { item: (typeof memeItems)[number] }) {
  const [liked, setLiked] = useState(false);
  const [done, setDone] = useState(false);

  const download = () => {
    setDone(true);
    window.setTimeout(() => setDone(false), 1600);
  };

  return (
    <article className="group animate-pop-in overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:shadow-soft">
      <div className="relative aspect-square overflow-hidden">
        <img
          src={item.image}
          alt={`梗图表情包：${item.title}`}
          title={`吃瓜快手梗图 ${item.title}`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 via-transparent to-transparent opacity-0 transition-opacity group-hover:opacity-100"></div>
        <button
          onClick={download}
          aria-label="下载"
          className="absolute right-3 top-3 flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-50 text-primary-600 opacity-0 shadow-soft transition-opacity hover:bg-primary-500 hover:text-background-50 group-hover:opacity-100"
        >
          <i className={done ? "ri-check-line text-base" : "ri-download-2-line text-base"}></i>
        </button>
        <div className="absolute bottom-3 left-3 right-3 translate-y-1 opacity-0 transition-all group-hover:translate-y-0 group-hover:opacity-100">
          <p className="whitespace-nowrap font-display text-base font-bold text-background-50">{item.title}</p>
          <p className="mt-0.5 whitespace-nowrap text-xs text-background-50/90">{item.subtitle}</p>
        </div>
      </div>
      <div className="flex items-center justify-between px-4 py-3">
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-semibold text-accent-700">
          <i className="ri-emotion-happy-line"></i>
          存图即正义
        </span>
        <div className="flex items-center gap-3">
          <button
            onClick={() => setLiked(!liked)}
            aria-label="点赞"
            className={`flex cursor-pointer items-center gap-1 whitespace-nowrap text-xs transition-colors ${
              liked ? "text-primary-600" : "text-foreground-500 hover:text-primary-600"
            }`}
          >
            <i className={liked ? "ri-heart-3-fill text-sm" : "ri-heart-3-line text-sm"}></i>
            {(item.like + (liked ? 1 : 0)).toLocaleString("zh-CN")}
          </button>
          <button
            onClick={() => {
              /* 加入收藏 */
            }}
            aria-label="收藏"
            className="cursor-pointer whitespace-nowrap text-xs text-foreground-500 hover:text-accent-700"
          >
            <i className="ri-bookmark-line text-sm"></i>
          </button>
        </div>
      </div>
    </article>
  );
}

export default function MemeWall() {
  return (
    <section id="memes" className="scroll-mt-24 bg-gradient-to-b from-background-100 to-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
              <i className="ri-emotion-2-fill"></i>
              表情包弹药库
            </span>
            <h2 className="mt-3 font-display text-3xl font-black text-foreground-900 md:text-4xl">
              梗图 &amp; 表情包 · 斗图必备
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-7 text-foreground-500 md:text-base">
              全网热梗表情包精选，聊到一半想怼人？存下这些图，你就是群聊里最靓的仔。
            </p>
          </div>
          <a
            href="#newsletter"
            className="hidden whitespace-nowrap rounded-full border border-secondary-200 px-5 py-2.5 text-sm font-semibold text-secondary-700 transition-colors hover:bg-secondary-100 md:inline-flex"
          >
            查看更多表情包
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {memeItems.map((item) => (
            <MemeCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}